import styled from 'styled-components';
import { tokens } from 'styles/tokens';
import { kendoPopupZIndex } from 'styles/variables';

export const FullScreenPopupContent = styled.div<{ $noPadding: boolean }>`
    z-index: ${kendoPopupZIndex};
    background: ${tokens.background.paperElevation8};
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '2rem')};
`;

export type PopupContentProps = Readonly<{
    $noPadding: boolean;
}>;

export const PopupContentWrapper = styled.div`
    z-index: ${kendoPopupZIndex};
    border-radius: 0.5rem;
    box-shadow: ${tokens.elevation['200']};
    border: ${tokens.popup.border};
    position: relative;
`;

export const PopupContent = styled.div<PopupContentProps>`
    border-radius: 0.5rem;
    background: ${tokens.background.paperElevation8};
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '2rem')};
    position: relative;
`;
